import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { HttpError } from "../api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [loginStr, setLoginStr] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login(loginStr, password);
      nav("/shipments", { replace: true });
    } catch (e) {
      if (e instanceof HttpError) setErr(e.message);
      else setErr("сбой сети");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-page">
      <div className="card">
        <h1>Вход в TEKSHER</h1>
        <form onSubmit={onSubmit}>
          <label>
            Логин
            <input
              type="text"
              value={loginStr}
              onChange={(e) => setLoginStr(e.target.value)}
              autoFocus
              required
            />
          </label>
          <label>
            Пароль
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {err && <div className="error">{err}</div>}
          <button type="submit" className="primary" disabled={busy}>
            {busy ? "..." : "Войти"}
          </button>
        </form>
      </div>
    </div>
  );
}
